"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENV_OPTIONS = ['test', 'dev', 'stag', 'canary', 'prod', 'cordova', 'usni', 'usni_dev'];
